import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {RouterModule} from "@angular/router";
import {PublicLayoutComponent} from "./public-layout/public-layout.component";
import {PrivateLayoutComponent} from "./private-layout/private-layout.component";
import {NavModule} from './nav/nav.module';
import {CalendarModule} from './calendar/calendar.module';
import {SelectedModule} from './selected/selected.module';
import {SuccessModule} from './success/success.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from "./services/auth.service";
import {ApiService} from "./services/api.service";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {AuthInterceptor} from "./services/auth.iterceptor";
import { NotfoundComponent } from './notfound/notfound.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { GdprComponent } from './gdpr/gdpr.component';
import { PageLayoutComponent } from './page-layout/page-layout.component';
import { DocumentsComponent } from './documents/documents.component';

@NgModule({
  declarations: [
    AppComponent,
    PublicLayoutComponent,
    PrivateLayoutComponent,
    NotfoundComponent,
    PrivacyPolicyComponent,
    GdprComponent,
    PageLayoutComponent,
    DocumentsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    NgbModule,
    NavModule,
    SuccessModule,
    CalendarModule,
    SelectedModule,
  ],
  providers: [
    AuthService,
    ApiService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
